async function UploadFile (fileToUpload, designfolderid, userid, designid, notes) {

    if (true) {

            let response;
            let formData = new FormData();

            formData.append("file", fileToUpload)
            formData.append("folder", "attachments");
            formData.append("data", JSON.stringify(
                { 
                    "designFolderId": designfolderid, 
                    "userId": userid, 
                    "designId": designid, 
                    "notes": notes
                }
            ));

            response = await fetch ("https://api.cssi.co/CNF/SaveFile", {
                method: "POST",
                body: formData})
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return response;
    }
}
 
export default UploadFile;